import { createComponent } from '@cloudflare/style-container'
// @ts-ignore
import * as React from 'react'

export const SidebarModulePadding = createComponent(() => ({
  padding: '0.8rem',
}))

export const SidebarAltTheme = createComponent(() => ({
  background: '#f7f9fa',
  borderTop: 'solid 1px #ccc',
}))

export const SidebarDarkTheme = createComponent(() => ({
  background: '#3b3f4a',
  color: '#fff',
}))

export const SidebarRaised = createComponent(() => ({
  position: 'relative',
  zIndex: 1,
  boxShadow: '0 3px 3px rgba(0, 0, 0, 0.15)',
}))

export const ButtonHotKey = createComponent(() => ({
  display: 'inline-block',
  fontSize: '0.8rem',
  marginRight: '-5px',
  paddingLeft: '2px',
}))



// WEBPACK FOOTER //
// ./src/components/FiddleSidebarModules.tsx